<!--
 * @Author: qinyifang
 * @Date: 2025-04-28 14:33:30
 * @Description: 应用根组件，管理组件缓存
-->
<script setup lang="ts"></script>

<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>
</template>

<style scoped></style>
